import React, { useState } from 'react';
import './RatingForm.css';

function RatingForm({ onSubmit }) {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0) {
      alert('Please select a rating');
      return;
    }

    setSubmitting(true);
    await onSubmit({ rating, comment });
    setRating(0);
    setComment('');
    setSubmitting(false);
  };

  const handleStarClick = (value) => {
    setRating(value);
  };

  const handleStarHover = (value) => {
    setHoveredRating(value);
  };

  const handleStarLeave = () => {
    setHoveredRating(0);
  };

  const renderStars = () => {
    const stars = [];
    const displayRating = hoveredRating || rating;

    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span
          key={i}
          className={`star ${i <= displayRating ? 'active' : ''}`}
          onClick={() => handleStarClick(i)}
          onMouseEnter={() => handleStarHover(i)}
          onMouseLeave={handleStarLeave}
        >
          ★
        </span>
      );
    }
    return stars;
  };

  return (
    <form onSubmit={handleSubmit} className="rating-form">
      <div className="star-rating-container">
        <label>Food Quality Rating *</label>
        <div className="star-rating">
          {renderStars()}
          {rating > 0 && (
            <span className="rating-text">
              {rating === 1 ? 'Poor' : 
               rating === 2 ? 'Fair' : 
               rating === 3 ? 'Good' : 
               rating === 4 ? 'Very Good' : 'Excellent'}
            </span>
          )}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="comment">Comment (Optional)</label>
        <textarea
          id="comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Share your thoughts about the food quality..."
          rows="4"
        />
        <small>Focus on taste, ingredients, preparation, and presentation only.</small>
      </div>

      <button type="submit" className="btn-submit" disabled={submitting || rating === 0}>
        {submitting ? 'Submitting...' : 'Submit Rating'}
      </button>
    </form>
  );
}

export default RatingForm;

